import React from 'react';
import PropTypes from 'prop-types';
import http from '../../shared/http';

const ArchiveCreativeButton = ({ creativeId, FlashService, mode, onClick }) => {
  const handleArchiveClick = () => {
    http
      .put(`/api/internal/partner_creative_previews/${creativeId}`, {
        shouldArchive: mode === 'archive'
      })
      .then(() => {
        FlashService.push(
          'success',
          `Creative ${creativeId} ${mode}d successfully`
        );
        onClick();
      })
      .catch(() => {
        FlashService.push('error', `Couldn't ${mode} creative ${creativeId}`);
      });
  };

  return (
    <button
      className="btn clickable enhanced-ads-table_archive-button"
      onClick={handleArchiveClick}
    >
      {mode === 'archive' ? 'Archive' : 'Unarchive'}
    </button>
  );
};

ArchiveCreativeButton.propTypes = {
  creativeId: PropTypes.number.isRequired,
  FlashService: PropTypes.shape({
    push: PropTypes.func
  }).isRequired,
  mode: PropTypes.oneOf(['archive', 'unarchive']).isRequired,
  onClick: PropTypes.func.isRequired
};

export default ArchiveCreativeButton;
